// @flow

import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _uniqBy from 'lodash/uniqBy';
import { createSelector } from 'reselect';

import { createValidationSchema } from '../../utils';

export const selectAllQuestions = state => _get(state, 'questions', []);

export const selectCurrentQuestionIndex = state => _get(state, 'currentQuestionIndex');

export const selectPreEditQuestionIndex = state => _get(state, 'preEditQuestionIndex');

export const selectIsAfterNext = state => _get(state, 'isAfterNext');

export const selectIsPreEdit = state => _get(state, 'isPreEdit');

export const selectQuestionsToBeAnswered = createSelector(selectAllQuestions, questions => {
  const fieldTradeType = questions.find(q => q.fieldName === 'tradeType');

  return questions.filter(
    q => !_isArray(q.onlyForTradeTypes) || q.onlyForTradeTypes.includes(fieldTradeType.fieldValue)
  );
});

export const selectCurrentQuestion = createSelector(
  selectQuestionsToBeAnswered,
  selectCurrentQuestionIndex,
  (questions, currentQuestionIndex) => questions.find(q => q.index === currentQuestionIndex)
);

export const selectAnsweredQuestions = createSelector(selectQuestionsToBeAnswered, questions =>
  questions.filter(q => q.isAnswered)
);

export const selectVisibleQuestions = createSelector(
  selectAnsweredQuestions,
  selectCurrentQuestion,
  (answeredQuestions, currentQuestion) => {
    const questions = _uniqBy(
      currentQuestion ? [...answeredQuestions, currentQuestion] : answeredQuestions,
      'fieldName'
    );
    const fieldTradeType = questions.find(q => q.fieldName === 'tradeType');
    const fieldDepositType = questions.find(q => q.fieldName === 'depositType');
    const { fieldValue: fieldValueTradeType } = fieldTradeType;
    const path =
      fieldDepositType && fieldDepositType.fieldValue === 'VL'
        ? 'SAVINGS_PLAN_VL'
        : fieldValueTradeType;

    return questions.map(q => {
      const {
        fieldValue,
        index,
        initialValue,
        label,
        notes,
        validations,
        inputConfigs,
        ...rest
      } = q;
      let validateSchema = null;

      if (validations) {
        const { rules, schemaType } = validations;
        const fieldRules = _get(rules, [path], rules);
        validateSchema = createValidationSchema({ rules: fieldRules, schemaType });
      }

      let filteredInputConfigs = inputConfigs;
      if (inputConfigs.options) {
        const { options, ...others } = inputConfigs;
        const filteredOpts = options
          .filter(
            o =>
              !_isArray(o.onlyForTradeTypes) ||
              o.onlyForTradeTypes.includes(fieldTradeType.fieldValue)
          )
          .map(o => {
            return { label: o.label, value: o.value };
          });

        filteredInputConfigs = { options: filteredOpts, ...others };
      }

      return {
        ...rest,
        inputConfigs: filteredInputConfigs,
        index,
        fieldValue: _defaultTo(fieldValue, _get(initialValue, [path], initialValue)),
        label: _get(label, [fieldValueTradeType], label),
        notes: _get(notes, [fieldValueTradeType], notes),
        validateSchema,
      };
    });
  }
);
